import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { stripDiacritics } from '../utils';

const HTML_ESCAPE_MAP: Readonly<Record<string, string>> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

const escapeHtml = (value: string): string => value.replace(/[&<>"']/g, (ch: string) => HTML_ESCAPE_MAP[ch]);

@Pipe({
  name: 'highlightMatch',
  standalone: true
})
export class HighlightMatchPipe implements PipeTransform {
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);

  transform(text: string, query: string | null | undefined): SafeHtml {
    const safeText: string = escapeHtml(text ?? '');
    const trimmed: string = (query ?? '').trim();
    if (!trimmed) return this.sanitizer.bypassSecurityTrustHtml(safeText);

    const normalizedText: string = stripDiacritics(text ?? '').toLowerCase();
    const normalizedQuery: string = stripDiacritics(trimmed).toLowerCase();

    const matchStart: number = normalizedText.indexOf(normalizedQuery);
    if (matchStart === -1) return this.sanitizer.bypassSecurityTrustHtml(safeText);

    const matchEnd: number = matchStart + normalizedQuery.length;
    const before: string = escapeHtml((text ?? '').slice(0, matchStart));
    const match: string = escapeHtml((text ?? '').slice(matchStart, matchEnd));
    const after: string = escapeHtml((text ?? '').slice(matchEnd));

    return this.sanitizer.bypassSecurityTrustHtml(`${before}<mark class="search-highlight">${match}</mark>${after}`);
  }
}
